import { InputProps } from "@hightouch/formkit";
import { SharedProps } from ".";
import { Controller, useFormContext } from "react-hook-form";
import { useEffect } from "react";
import { FormkitInput } from "src/formkit/components";

export const FKInput = ({
  default: defaultValue,
  error,
  max,
  min,
  name,
  placeholder,
  prefix,
  readOnly,
  style,
  type,
  value,
  query,
  isDisabled,
}: InputProps & { type: any } & SharedProps) => {
  const { control, setValue } = useFormContext();
  const hardcodedValue = value
    ? typeof value === "string"
      ? value
      : query.data
    : undefined;

  // TODO(eric.lovett): This `biome-ignore` was part of a blanket suppression so that we could
  // turn on the rule. It is probably covering up a real bug. Please fix this or replace this
  // TODO with an explanation of why we don't want all deps listed.
  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy suppression, probably a bug
  useEffect(() => {
    if (hardcodedValue != null) {
      setValue(name, hardcodedValue);
    }
  }, [hardcodedValue]);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <FormkitInput
          prefix={prefix?.toString()}
          disabled={isDisabled}
          invalid={Boolean(error)}
          readonly={readOnly}
          min={min}
          max={max}
          placeholder={placeholder?.toString()}
          type={type}
          defaultValue={defaultValue}
          value={hardcodedValue ?? field.value ?? ""}
          onBlur={field.onBlur}
          style={style}
          onChange={(event) => {
            const value = event.target.value;
            if (type === "number") {
              // Number("") is 0, which fails positive validations.
              // A cleared input must unset the field instead.
              field.onChange(value === "" ? undefined : Number(value));
            } else {
              field.onChange(value ?? undefined);
            }
          }}
        />
      )}
    />
  );
};
